import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import OutlinedInput from '@material-ui/core/OutlinedInput';

class OutlinedSelect extends React.Component {
    render() {
        const { id, label, labelClasses, error, name, value, children, ...rest } = this.props;
        return (
            <FormControl
                variant="outlined"
                margin={this.props.margin}
                fullWidth={this.props.fullWidth !== undefined ? this.props.fullWidth : true}
                error={error}
            >
                <InputLabel id={'Label' + id} htmlFor={id} classes={labelClasses}>
                    {label}
                </InputLabel>
                <Select
                    id={id}
                    name={name}
                    labelId={'Label' + id}
                    value={value}
                    {...rest}
                    input={<OutlinedInput name={name} {...(label && { label: label })} />}
                >
                    {children}
                </Select>
            </FormControl>
        );
    }
}

export default OutlinedSelect;
